module.exports = __webpack_public_path__ + "img/fondo-banner-principal.f36548aa.svg";